import React from "react";
import { StyledContainerRow } from "../../../components/ModalComponents/StyledModalComponents";
import SleeperTypeModal from "./SleeperTypeModal";
import SleeperPainPointsModal from "./SleeperPainPointsModal";

const EvrSleeperPainPointsModal = () => {
  return (
    <StyledContainerRow className="row w-100">
      <div className="col-3"></div>
      <SleeperPainPointsModal></SleeperPainPointsModal>
      <div className="col-4"></div>
    </StyledContainerRow>
  );
};

export default EvrSleeperPainPointsModal;
